module.exports = __webpack_public_path__ + "static/media/search-icon.2ebdbeb3.svg";